var _style, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSecuritiSymbol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 129 30",
    style: {
      enableBackground: "new 0 0 129 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#1CA8DD;}\n\t.st2{fill:#1CA8DD;}\n\t.st3{fill:#1F2229;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 127.9,
    height: 30
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.9,0.3C2.9-1.1-1,2.8,0.3,6.8l2.1,6.5c0.3,1.1,0.3,2.2,0,3.3l-2.2,6.5c-1.4,4.1,2.5,7.9,6.5,6.6l6.6-2.2 c1.1-0.3,2.2-0.4,3.2,0l6.5,2.1c4.1,1.3,7.9-2.5,6.5-6.6l-2.2-6.4c-0.4-1.1-0.4-2.2,0-3.3l2.2-6.6c1.4-4.1-2.5-7.9-6.6-6.6 l-6.5,2.2c-1.1,0.4-2.2,0.4-3.3,0L6.9,0.3z M15,22.8c2.1,0,4.1-0.8,5.5-2.3c1.5-1.5,2.3-3.5,2.3-5.5s-0.8-4.1-2.3-5.5 C19.1,8,17.1,7.1,15,7.1S10.9,8,9.5,9.4C8,10.9,7.2,12.9,7.2,15s0.8,4.1,2.3,5.5C10.9,22,12.9,22.8,15,22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M12.7,17.3c0.3,0.3,0.7,0.5,1.1,0.7c0.4,0.2,0.8,0.2,1.3,0.2c0.4,0,0.9-0.1,1.3-0.3c0.4-0.2,0.8-0.4,1.1-0.7 c0.3-0.3,0.5-0.7,0.7-1.1c0.2-0.4,0.2-0.8,0.2-1.3c0-0.4-0.1-0.9-0.3-1.3c-0.2-0.4-0.4-0.8-0.7-1.1c-0.6-0.6-1.5-1-2.3-1 c-0.9,0-1.7,0.3-2.3,1c-0.6,0.6-1,1.5-1,2.3C11.7,15.9,12.1,16.7,12.7,17.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M50.5,11.7c-0.3-3.4-3.1-4.3-5.1-4.3c-2.8,0-5.1,1.7-5.1,4.5c0,2.1,1.6,3.1,3.5,3.7c2.6,0.9,3.7,1.2,3.7,2.5 c0,1-0.9,1.7-2,1.7c-0.6,0-2-0.3-2.1-1.8H40c0.3,3.5,3.2,4.6,5.5,4.6c3,0,5.5-1.9,5.4-4.8c0-3.1-2.5-3.7-4.8-4.4 c-1.4-0.4-2.4-0.9-2.4-1.8c0-0.7,0.5-1.4,1.7-1.4c1.3,0,1.7,0.8,1.7,1.5H50.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M67,16.1c0.3-2.5-0.4-4.7-2.1-6.5c-1.3-1.4-3.2-2.2-5.3-2.2c-4.3,0-7.5,3.6-7.5,7.6c0,4,3.1,7.5,7.5,7.5 c1.5,0,2.9-0.4,4.1-1.2c1.2-0.8,2.2-2,2.9-3.6H63c-0.7,1.2-1.8,1.9-3.4,1.9c-2,0-4-1.2-4.1-3.5H67z M55.5,13.5 c0.1-1.4,1.5-3.2,4-3.2c2.5,0,3.9,1.9,4.1,3.2H55.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M79.8,16.9c-0.5,1.2-1.7,2.4-3.8,2.4c-2.4,0-4.2-1.8-4.2-4.4c0-1.2,0.4-2.4,1.2-3.2c0.8-0.8,1.8-1.2,3-1.2 c1.9,0,3.2,1.1,3.8,2.6h3.5c-0.8-3.5-3.9-5.7-7.5-5.7c-4.3,0-7.5,3.4-7.5,7.6c0,4.1,3.1,7.6,7.6,7.6c3.7,0,6.5-2.5,7.3-5.6H79.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M98.4,7.9H95v7.9c0,2-0.8,3.6-3.3,3.6c-2.4,0-3.1-1.6-3.1-3.7V7.9h-3.4v8.6c0,2.5,0.9,6.1,5.6,6.1 c2.6,0,3.8-1.2,4.4-2.3v1.9h3.2V7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M101.3,22.1h3.4v-7.7c0-2.5,1.2-3.6,3.6-3.6h0.2V7.4c-2.2,0-3.3,1-4,2.3V7.9h-3.2V22.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M110,6h3.4v-3H110V6z M110,22.1h3.4V7.9H110V22.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M117.2,22.1h3.4V10.5h2.4V7.9h-2.4v-5h-3.4v5h-2.4v2.6h2.4V22.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M124.5,6h3.4v-3h-3.4V6z M124.5,22.1h3.4V7.9h-3.4V22.1z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSecuritiSymbol);
export default __webpack_public_path__ + "static/media/logo-securiti-symbol.f12d306a.svg";
export { ForwardRef as ReactComponent };